module.exports = __webpack_public_path__ + "static/media/ee.67b62b14.svg";